export default (amount: number, min: number | null = null, max: number | null = null): boolean => {
  return !((min !== null && min > amount) || (max !== null && max < amount))
}
